module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-services page-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "service1"
  }, [_c('Header'), _c('div', {
    staticClass: "service-inner inner-container clear"
  }, [_c('div', {
    staticClass: "service-left"
  }, [_c('h2', [_vm._v("SERVICES")]), _c('router-link', {
    attrs: {
      "to": "/prevention"
    }
  }, [_vm._v("prevention")]), _c('router-link', {
    attrs: {
      "to": "/implant"
    }
  }, [_vm._v("implants")]), _c('router-link', {
    attrs: {
      "to": "/invisalign"
    }
  }, [_vm._v("invisalign")]), _c('router-link', {
    staticClass: "active",
    attrs: {
      "to": "/surgery"
    }
  }, [_vm._v("surgery")]), _c('router-link', {
    attrs: {
      "to": "/restorative"
    }
  }, [_vm._v("restorative")]), _c('router-link', {
    attrs: {
      "to": "/cosmetic"
    }
  }, [_vm._v("cosmetic ")])], 1), _c('div', {
    staticClass: "service-right"
  }, [(_vm.props) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.title)
    }
  }) : _vm._e(), (_vm.props) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.sub_tilte)
    }
  }) : _vm._e(), _c('hr'), _vm._l((_vm.props.acf.service_repeator), function(serviceContent) {
    return (_vm.props.acf.service_repeator) ? _c('div', {
      staticClass: "sub-content-outer"
    }, [_c('div', {
      staticClass: "sub-content clear"
    }, [_c('img', {
      attrs: {
        "src": serviceContent.image
      }
    }), _c('div', {
      staticClass: "sub-content-text"
    }, [(serviceContent.mouse) ? _c('div', {
      staticClass: "mouse"
    }, [_c('span')]) : _vm._e(), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(serviceContent.title)
      }
    }), _c('div', {
      staticClass: "contentt",
      domProps: {
        "innerHTML": _vm._s(serviceContent.content)
      }
    })])]), _c('hr')]) : _vm._e()
  }), _c('div', {
    staticClass: "patient-section"
  }, [_c('div', {
    staticClass: "request_consult_sec"
  }, [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [(_vm.props.acf.request_consultation_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.request_consultation_text)
    }
  }) : _vm._e()])], 1)])], 2)]), _c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "bottom-contact"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.propsacf.data.acf.header_phone_number)
    }
  }), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.propsacf.data.acf.header_address)
    }
  })])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3df0bd1c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/surgery/surgery.pug
// module id = 538
// module chunks = 1